(function () {
  let config

  document.querySelectorAll('[data-quantity-discount-frame]')
    .forEach(elem => {
      config = JSON.parse(elem.dataset.quantityDiscountFrame)
      update()

      document.documentElement.addEventListener('wetheme-cart-update', check)
      document.documentElement.addEventListener('wetheme-toggle-right-drawer', check)
      document.addEventListener('wetheme-change-quantity', check)
    })

  function check (event) {
    const virtualQuantity = event?.detail?.quantity || 0
    fetch('/cart?view=discount')
      .then(response => response.json())
      .then(response => {
        const total = response.items.reduce(
          (accumulator, item) => accumulator + (
            item['count_for_discount'] ? item.quantity : 0
          ), 0,
        )

        if (config.count !== total + virtualQuantity) {
          config.count = total + virtualQuantity
          update()
        }
      })
  }

  function update () {
    document.querySelectorAll('[data-quantity-discount-frame]')
      .forEach(elem => {
        elem.querySelector('.product-quantity-discount')
          .classList.toggle('hidden', false)

        let next_discount
        let pending
        let key

        if (config.count < 2) {
          key = 'ten_percent'
          pending = 2 - config.count
        } else if (config.count < 3) {
          key = 'fifteen_percent'
          pending = 3 - config.count
        } else if (config.count < 4) {
          key = 'twenty_percent'
          pending = 4 - config.count
        }

        const qtyDescription = elem.querySelector('.product-quantity-discount-description')

        let label
        if (pending) {
          label = pending > 1
            ? config.label.description[key]?.['plural']
            : config.label.description[key]?.['singular']

          label = label?.replace('%pending%', pending)
        } else {
          label = config.label?.description['completed']
        }

        qtyDescription.innerHTML = label

        const discountGraph = elem.querySelector('.product-quantity-discount-graph')
        const dots = discountGraph.children
        let n = 0

        const count = Math.min(4, config.count)
        for (const dot of dots) {
          n++
          dot.classList.toggle('completed', n < count)
          dot.classList.toggle('current', n === count)
        }

        const percentage = Math.min((config.count / 4) * 100, 100)
        discountGraph.style.setProperty('--percentage', percentage + '%')
      })
  }
})()
